import React, { useContext, useState, useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import Layout from '@/product/components/templates/Layout'
import CustomTable from '@/product/components/molecules/CustomTable'
import CustomSearch from '@/product/components/molecules/CustomSearch'
import { useFormik } from 'formik'
import AgencyContext from '@/product/context/agency/agencyContext'
import ReportContext from '@/product/context/report/reportContext'
import { handleRedirectInternal } from '@/product/common/components'
import PrimaryButton from '@/product/components/atoms/PrimaryButton'
import CustomDialog from '@/product/components/organisms/Dialog'
import AuthContext from '@/product/context/auth/authContext'
import '../Dashboard/Dashboard.css'
import { Button } from '@mui/material'
import SettingContext from '@/product/context/setting/settingContext'
import CustomCommonContext from '@/custom/context/common/commonContext'
import AgencyManage from './view'

let randomVariable = Math.random()

const AgencyView = (props) => {
    const [isLoading, setIsLoading] = useState(false)
    const agencyContext = useContext(AgencyContext)
    const authContext = useContext(AuthContext)
    const reportContext = useContext(ReportContext)
    const settingcontext = useContext(SettingContext)
    const customCommonContext = useContext(CustomCommonContext)
    const history = useHistory()

    const { getAllExportDownload } = reportContext
    const {
        all_agency,
        agencyAction,
        getAllAgency,
        changeAgencyStatus,
        responseStatus: responseStatusAgency,
        clearResponse: clearResponseUser,
    } = agencyContext
    const { updateConfigColumn } = settingcontext
    const { allAgencies } = customCommonContext

    const { user } = authContext
    const [changeStatus, setChangeStatus] = React.useState(false)
    const [allAgency, setAllAgency] = React.useState([])
    const [manage, setManage] = React.useState({
        popup: false,
        status: 'new',
        id: 0,
    })
    const [filteredAgencies, setFilteredAgencies] = useState([])

    const changeChangeStatus = () => {
        setChangeStatus(!changeStatus)
    }

    const toggleFullScreenPopup = (popup, status, id) => {
        console.log('i am toggleFullScreenPopup = ', popup, status, id)
        if (popup) {
            setManage({ popup, status, id })
        } else {
            setManage({ popup, status: 'new', id: 0 })
        }
    }

    useEffect(() => {
        console.log('i am toggleFullScreenPopup manage = ', manage)
    }, [manage])

    let action =
        props.match.params.action !== 'all' ? props.match.params.action : null

    const [tableBody, setTableBody] = useState([])
    console.log(user, 'checkUser')
    const formik = useFormik({
        initialValues: {
            page: 1,
            limit: 20,
            order: '',
            orderby: '',
            fetchTables: ['agencies_address', 'agencies_phone'],
            filters: {
                agency_name: {
                    value: '',
                    type: 'like',
                    field: 'ag.agency_name',
                },
                id: {
                    value: '',
                    type: 'like',
                    field: 'ag.id',
                },
                agency: {
                    value:
                        user?.emp_type === 'agency' ? user?.emp_agencies : '',
                    type: 'array',
                    field: 'ag.id',
                },
            },
        },
        onSubmit: (values) => {
            setIsLoading(true)
            randomVariable = Math.random()
            console.log('i am agency management 1 ', randomVariable)
            getAllAgency(values, randomVariable)
        },
    })

    useEffect(() => {
        setTableBody([])
        setIsLoading(true)
        formik.values.page = 1
        randomVariable = Math.random()
        console.log('i am agency management 2 ', randomVariable)
        getAllAgency(formik.values, randomVariable)
    }, [action])

    useEffect(() => {
        console.log('i am agency management 3 ', randomVariable, all_agency)
        if (all_agency?.records?.length) {
            // if (all_agency?.records?.length && all_agency?.from === randomVariable) {
            let _allAgency = [...all_agency?.records]
            let allAgency = []
            _allAgency.map((each) => {
                let eachAgency = { ...each }
                eachAgency['phone'] = each.agencies_phone?.length
                    ? each.agencies_phone.map((eachPhone) => {
                          return eachPhone?.is_default
                              ? eachPhone?.phone
                              : each.agencies_phone[0]?.phone
                      })[0]
                    : '-'
                eachAgency['address'] = each.agencies_address?.length
                    ? each.agencies_address.map((eachAddress) => {
                          return eachAddress?.is_default
                              ? eachAddress?.address_line_1
                              : each.agencies_address[0]?.address_line_1
                      })[0]
                    : '-'
                allAgency.push(eachAgency)
            })
            console.log(allAgency, 'allooooooo')
            setAllAgency(allAgency)
            setTableBody(allAgency)
        } else {
            setAllAgency([])
            setTableBody([])
        }
        setIsLoading(false)
    }, [all_agency])

    const onClickEdit = (id, type) => {
        console.log(id, type, 'onClickEditCheck')
        // toggleFullScreenPopup(true, 'edit', id)
        handleRedirectInternal(history, `agency/edit/${id}`)
    }
    const formikSelection = useFormik({
        initialValues: {
            action: '',
            agency_id: '',
        },
        onSubmit: (values) => {
            if (values.action === 'active' || values.action === 'deactivate') {
                setIsLoading(true)
                changeAgencyStatus(values)
            }
        },
    })

    const onSelectMultiProducts = (data, action) => {
        formikSelection.values.action = action
        formikSelection.values.agency_id = data
        if (action === 'active' || action === 'deactivate') {
            setChangeStatus(true)
        }
    }

    const getMultipleAction = () => {
        let actionPush = [
            {
                buttonType: 'edit',
                clickType: 'edit',
                onclick: onClickEdit,
                tooltipTitle: 'Edit User',
            },
        ]
        return actionPush
    }

    useEffect(() => {
        if (user?.emp_type && user.emp_type === 'agency') {
            if (allAgencies && allAgencies.length) {
                if (user && user.emp_agencies) {
                    let filteredPreAgencies = allAgencies
                        .filter((d) => {
                            return user.emp_agencies
                                .toString()
                                .split(',')
                                .includes(d.id.toString())
                        })
                        .map((subcat) => {
                            let subCategoryChanged = {}
                            subCategoryChanged.show = subcat.agency_name
                            subCategoryChanged.value = subcat.id?.toString()
                            return subCategoryChanged
                        })

                    // if (filteredPreAgencies.length) {
                    //     formik.values.filters.agency =
                    //         filteredPreAgencies[0].value
                    // }

                    setFilteredAgencies(filteredPreAgencies)
                }
            }
        }
    }, [allAgencies, user])

    console.log(filteredAgencies, 'filteredAgencies')

    const tableValues = [
        {
            field: 'id',
            type: 'number',
            firstChild: true,
            sort: true,
            filterable: true,
            label: 'Agency #',
            filterField: 'ag.id',
        },
        {
            field: 'agency_name',
            type: 'hyperlink',
            clickID: 'id',
            onclick: onClickEdit,
            firstChild: false,
            sort: true,
            filterable: true,
            disablePadding: false,
            label: 'Agency Name',
            filterField: 'ag.agency_name',
        },
        {
            field: 'phone',
            type: '',
            sort: false,
            filterable: false,
            firstChild: false,
            disablePadding: false,
            label: 'Phone',
        },
        {
            field: 'address',
            type: 'capitalize',
            sort: false,
            filterable: false,
            firstChild: false,
            disablePadding: false,
            label: 'Address',
        },
        {
            field: 'active',
            type: 'boolean',
            sort: true,
            firstChild: false,
            disablePadding: false,
            label: 'Status',
            filterable: true,
            filterField: 'ag.active',
        },
        {
            field: 'action',
            type: 'button',
            clickID: 'id',
            sort: false,
            filterable: false,
            firstChild: false,
            disablePadding: false,
            label: 'Action',
            isMultiple: getMultipleAction(),
        },
    ]

    const searchInfo = {
        formik: formik,
        data: [
            {
                label: 'Agency Name',
                placeholder: 'Enter Agency Name',
                class: `col-md-4 col-sm-6 col-12 ${
                    user?.emp_type && user.emp_type === 'agency' ? 'd-none' : ''
                }`,
                type: 'text',
                name: 'agency_name',
                filter: true,
            },
            {
                label: 'Agency #',
                placeholder: 'Enter Agency #',
                class: 'col-md-4 col-sm-6 col-12',
                type: 'text',
                name: 'id',
                filter: true,
            },
            {
                label: 'Agency',
                type: 'select',
                isNoDefaultOptionValue: false,
                placeholder: 'Select an Agency',
                class: `col-md-4 col-sm-6 col-12 ${
                    user?.emp_type && user.emp_type === 'agency' ? '' : 'd-none'
                }`,
                size: 'small',
                name: 'agency',
                filter: true,
                options: filteredAgencies,
            },
        ],
    }
    console.log(user?.emp_agencies, 'user?.emp_agencies')
    const tableActions = []

    if (action === 'active') {
        tableActions.push({
            label: 'Move to De-activate',
            icon: <span className="material-icons">block</span>,
            onclick: onSelectMultiProducts,
            type: 'deactivate',
        })
    }
    if (action === 'deactivate') {
        tableActions.push({
            label: 'Move to Activate',
            icon: <span className="material-icons">check_circle</span>,
            onclick: onSelectMultiProducts,
            type: 'active',
        })
    }

    if (action === 'all' || !action) {
        tableActions.push(
            {
                label: 'Move to De-activate',
                icon: <span className="material-icons">block</span>,
                onclick: onSelectMultiProducts,
                type: 'deactivate',
            },
            {
                label: 'Move to Activate',
                icon: <span className="material-icons">check_circle</span>,
                onclick: onSelectMultiProducts,
                type: 'active',
            }
        )
    }
    console.log(responseStatusAgency, 'responseStatusAgency')
    useEffect(() => {
        if (responseStatusAgency) {
            if (responseStatusAgency.status === 'success') {
                // updateConfigColumn(null, true)

                if (responseStatusAgency.from === 'changeStatus') {
                    setChangeStatus(false)
                    randomVariable = Math.random()
                    console.log('i am agency management 4 ', randomVariable)
                    getAllAgency(formik.values, randomVariable)
                    console.log(formik.values, 'changeStatus')
                }
                if (responseStatusAgency.from === 'employeeAction') {
                    toggleFullScreenPopup(false)
                    randomVariable = Math.random()
                    console.log('i am agency management 5 ', randomVariable)
                    getAllAgency(formik.values, randomVariable)
                    console.log(formik.values, 'employeeAction')
                }
            } else if (responseStatusAgency.status === 'error') {
                if (responseStatusAgency.from === 'employeeAction') {
                    toggleFullScreenPopup(false)
                }
            }
        }
    }, [responseStatusAgency])

    useEffect(() => {
        if (responseStatusAgency?.status === 'success') {
            // updateConfigColumn(null, true)
            getAllAgency(formik.values, randomVariable)
        }
    }, [responseStatusAgency])

    console.log(all_agency, 'checkall_agency')
    const exportFields = [
        {
            field: 'id',
            type: '',
            name: 'Agency Number',
        },
        {
            field: 'agency_name',
            type: 'string',
            name: 'Agery Name',
        },
        {
            field: 'agency_name',
            type: '',
            name: 'Agency Type',
        },
        {
            field: 'agency_short_name',
            type: '',
            name: 'Agency Short Name',
        },
        {
            field: 'created_at',
            type: 'datetime',
            name: 'Created At',
        },
        {
            field: 'parent_agency_id',
            type: 'customOptions',
            name: 'Parent Agency',
            table: {
                options: [
                    { id: 1, description: 'State Agency' },
                    { id: 2, description: 'Local Unit of Government(LUG)' },
                ],
                showField: 'description',
                valueField: 'id',
            },
        },
        {
            field: 'active',
            type: '',
            name: 'Status',
        },
    ]
    return (
        <Layout>
            <div className="dashboard employeeManagement">
                <CustomSearch searchInfo={searchInfo} formik={formik} />
                {user?.emp_type !== 'agency' ? (
                    <div className="miscActions d-flex justify-content-between align-items-center mt-4 flex-wrap">
                        <div>
                            <Button
                                id="employee_add"
                                variant="outlined"
                                className="btnOutlined"
                                onClick={() =>
                                    handleRedirectInternal(
                                        history,
                                        `agency/new/0`
                                    )
                                }
                            >
                                <span className="material-icons">
                                    person_add_alt_1
                                </span>
                                Add New Agency
                            </Button>
                        </div>
                        <Button
                            className="exportAllBtn"
                            onClick={() =>
                                getAllExportDownload({
                                    fields: exportFields,
                                    replaceObjects: exportFields,
                                    action: 'export',
                                    isDefault: false,
                                    order: 'asc',
                                    orderby: '',
                                    search: 'all',
                                    report: `customData`,
                                    baseTable: 'agencies',
                                    customTable: false,
                                    topheading: 'Agencies',
                                })
                            }
                        >
                            <span className="material-icons">get_app</span>
                            Export All Data
                        </Button>
                    </div>
                ) : null}

                {console.log(tableValues, 'tableValuesCheck')}
                {console.log(tableBody, 'tableBodyCheck')}
                {console.log(formik.values, 'formik.values')}

                <CustomTable
                    formik={formik.values}
                    tableBody={tableBody}
                    tableValues={tableValues}
                    tableActions={tableActions}
                    allData={all_agency}
                    isLoading={isLoading}
                    loadingTemplate={'table'}
                    columnStorageVariable={'table_agency_list_page'}
                    changeTableFunction={getAllAgency}
                    fromVariable={randomVariable}
                />
            </div>
            {/* <AgencyManage
                data={manage}
                allData={allAgency}
                function={toggleFullScreenPopup}
            /> */}
            <CustomDialog
                title={'Change agency status'}
                open={changeStatus}
                function={changeChangeStatus}
            >
                <h5>Are you sure you want to change the status</h5>
                <div className="actionWrapper">
                    <Button
                        id="employee_cancel"
                        onClick={() => changeChangeStatus()}
                    >
                        Cancel
                    </Button>
                    <form
                        onSubmit={formikSelection.handleSubmit}
                        autoComplete="nofill"
                    >
                        <PrimaryButton
                            id="employee_confirm"
                            type="submit"
                            label="Confirm"
                        />
                    </form>
                </div>
            </CustomDialog>
        </Layout>
    )
}

export default AgencyView
